import { useAtomValue } from 'jotai'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { activeTabAtom } from 'src/pages/DiscoverPage/discover-store'

const OffersNoResults = () => {
  const activeTab = useAtomValue(activeTabAtom)
  const { t } = useTranslation('offersManagement', { keyPrefix: 'offersList' })

  return (
    <div className='flex flex-col items-center justify-center px-2 py-6 rounded bg-paper-muted text-center'>
      <div className='text-main-muted text-lg font-semibold'>
        {t('noOffers')}
      </div>
      <div className='mt-3 text-main-muted text-sm'>
        {activeTab !== 'private' ? (
          <Trans
            ns='offersManagement'
            i18nKey='offersList.noOffersCreateSuggestion'
            components={[
              <Link
                className='text-primary hover:underline'
                to='/trade/limit'
              />,
            ]}
          />
        ) : (
          t('noOffersSuggestion')
        )}
      </div>
    </div>
  )
}

export default OffersNoResults
